export default __webpack_public_path__ + "static/media/instagram_icon.b896dbc1.webp";